var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 167.27 167.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_32);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_32",
    x1: 9.4,
    y1: 157.76,
    x2: 158.02,
    y2: 9.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#659edd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9e82e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967ef5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.48,0c17.33,0,34.65-.1,52,0,15.05.11,27.22,9.5,30.79,23.7a38.9,38.9,0,0,1,1,9.39c0,33.81-.19,67.62,0,101.43.07,16.64-11.24,29.22-25.45,32a39.31,39.31,0,0,1-7.44.58c-33.82,0-67.64-.26-101.45.07A32.24,32.24,0,0,1,0,134.5c.18-34,0-67.95,0-101.93C.07,16.67,9.66,4.38,24.59.93A40.23,40.23,0,0,1,33.51.17c16.66-.07,33.32,0,50,0ZM116,67.32c.26-4.12-2-7.11-6.14-7.83a24.26,24.26,0,0,0-6,0c-6.8.52-13.6,1.12-20.39,1.7-11.28,1-22.55,1.89-33.82,2.93-4.42.41-6.84,2.45-7.65,6.58C39.79,82,37.63,93.24,35.6,104.53c-.91,5.1,1.7,8.32,6.89,8.8,2.31.22,4.66,0,7,.13,3.69.16,4.27.9,3.79,4.6s-1.15,7.57-1.44,11.38c-.17,2.27,1.28,3,3.21,1.8A21.62,21.62,0,0,0,57.71,129c4.88-4.28,9.83-8.48,14.6-12.89a9.49,9.49,0,0,1,7.15-2.75c6.49.15,13,.08,19.47,0,6.8-.06,8.92-1.88,10.11-8.41.83-4.58,1.74-9.15,2.58-13.72C113.09,83.25,114.53,75.23,116,67.32Zm23.59-7.9c-.84-12.52-10.17-23-24.2-24-2.71-.19-4.46,1.3-4.5,3.54,0,2.58,1.68,3.23,3.84,3.65,2.59.5,5.34.87,7.63,2,6.21,3.18,9.55,8.41,10.17,15.45.26,3.09,1.69,4.33,3.84,4.11S139.63,62.26,139.56,59.42ZM114.2,46.94l-.5,0c-2.21-.13-4,.56-4.52,2.91-.42,1.8.93,3.7,3.43,4,5.21.72,7.89,3.49,8.59,8.66.34,2.44,2.31,3.78,4.12,3.31,2.08-.52,2.75-2,2.82-4.1C128.39,54.47,121.67,47.28,114.2,46.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.005d77ac19ee7b48813012276e45b33d.svg";
export { ForwardRef as ReactComponent };